var _SocketReactionCommand_socket;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class SocketReactionCommand {
    constructor(socket) {
        _SocketReactionCommand_socket.set(this, void 0);
        __classPrivateFieldSet(this, _SocketReactionCommand_socket, socket, "f");
    }
    execute(privateKey, chatHash, reaction) {
        __classPrivateFieldGet(this, _SocketReactionCommand_socket, "f").send({
            commandType: 'reaction',
            resource: { userKey: privateKey, chatHash, reaction },
        });
    }
}
_SocketReactionCommand_socket = new WeakMap();
